import React from 'react';
import PropTypes from 'prop-types';
import useForceUpdate from '../../../utils/useForceUpdate';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Link from '../../Link';
import Box from '@material-ui/core/Box';
import Wrap from './Wrap';

const useStyles = makeStyles(theme => ({
  signAgainButton: {
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.grey[200],
    },
  },
}));

const NewsletterSection = props => {
  const { noTitle } = props;
  const classes = useStyles();
  const forceUpdate = useForceUpdate();
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : `/depi/`;
  return (
    <Wrap bgcolor="primary.light">
      {!noTitle && (
        <Typography
          variant="h2"
          color="secondary"
          align="center"
          data-underline
          data-underline-white
        >
          {' '}
          Newsletter{' '}
        </Typography>
      )}
      <Typography variant="h6" color="secondary" align="center">
        {' '}
        Jetzt Newsletter abonnieren und keine Neuigkeiten mehr verpassen.{' '}
      </Typography>
      <Box textAlign="center" mt={4}>
        <Link href={`${linkContext}newsletter`} passHref>
        <Button
          variant="outlined"
          color="secondary"
          size="large"
        >
          Anmelden
        </Button>
        </Link>
      </Box>
    </Wrap>
  );
};

export default NewsletterSection;
